import type { ReactNode } from 'react';
import track from 'react-tracking';
import { Modal } from '@simplywallst/ui-core';
import { useOverviewTranslation } from '@/pages/CompanyReport/components/OverviewSection/hooks/useOverviewTranslation';

interface HelpModalProps {
  title?: string;
  onClose: () => void;
  children?: ReactNode;
}

const HelpModal = ({ title, onClose, children }: HelpModalProps) => {
  const t = useOverviewTranslation();
  return (
    <Modal
      title={title}
      onSecondaryClick={onClose}
      onPrimaryClick={onClose}
      primaryLabel={t('actions.close')}
    >
      {children}
    </Modal>
  );
};

export default track(({ title }) => ({
  type: 'track',
  chart: title,
  subject: 'HelpModal',
}))(HelpModal);
